import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import '@material/web/fab/fab.js';
import '@material/web/icon/icon.js';

export type FabVariant = 'surface' | 'primary' | 'secondary' | 'tertiary';
export type FabSize = 'medium' | 'small' | 'large';

export class IxFab extends LitElement {
  /**
   * Lowers the FAB's elevation.
   */
  @property({ type: Boolean, reflect: true }) lowered = false;

  /**
   * Changes the colour of the FAB
   */
  @property() variant: FabVariant = 'surface';

  /**
   * The text to display on the FAB.
   */
  @property() label: string = '';

  /**
   * The size of the FAB.
   */
  @property() size: FabSize = 'medium';

  // eslint-disable-next-line class-methods-use-this
  @property() onClick: (event: MouseEvent) => void = () => {};

  render() {
    return html`
      <md-fab
        .label=${this.label}
        .lowered=${this.lowered}
        .size=${this.size}
        .variant=${this.variant}
        @click=${this.onClick}
      >
        <slot slot="icon"></slot>
      </md-fab>
    `;
  }
}
